import MealPhotoRecognition from '../MealPhotoRecognition';
import BarcodeScanner from '../BarcodeScanner';
import VoiceMealLogger from '../VoiceMealLogger';
import MealTracker from '../MealTracker';
import MealPlanner from '../MealPlanner';
import CalorieCalculator from '../CalorieCalculator';

export default function NutritionTab({ childId, childName, childData, onMealLogged }) {
  const handleMealLogged = () => {
    if (onMealLogged) onMealLogged();
  };

  return (
    <div className="space-y-6" data-testid="nutrition-tab">
      {/* Calorie Calculator */}
      <CalorieCalculator 
        childData={childData}
        onSaveGoals={() => {}}
      />
      
      {/* Quick Logging Options */}
      <div className="grid md:grid-cols-2 gap-4">
        {/* Photo Recognition */}
        <div className="bg-gradient-to-r from-purple-500/10 to-pink-500/10 border border-purple-500/30 rounded-xl p-4">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="font-bold text-white flex items-center gap-2">
                <span className="text-xl">📸</span> Photo Scan
              </h3>
              <p className="text-xs text-zinc-400">AI identifies foods from photos</p>
            </div>
            <MealPhotoRecognition 
              childId={childId}
              onMealLogged={handleMealLogged}
            />
          </div>
        </div>
        
        {/* Barcode Scanner */}
        <div className="bg-gradient-to-r from-blue-500/10 to-cyan-500/10 border border-blue-500/30 rounded-xl p-4">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="font-bold text-white flex items-center gap-2">
                <span className="text-xl">📊</span> Barcode Scan
              </h3>
              <p className="text-xs text-zinc-400">Instant lookup for packaged foods</p>
            </div>
            <BarcodeScanner 
              childId={childId}
              onProductLogged={handleMealLogged}
            />
          </div>
        </div>
        
        {/* Voice Meal Logger */}
        <div className="bg-gradient-to-r from-purple-500/10 to-pink-500/10 border border-purple-500/30 rounded-xl p-4">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="font-bold text-white flex items-center gap-2">
                <span className="text-xl">🎤</span> Voice Log
              </h3>
              <p className="text-xs text-zinc-400">Log meals by speaking</p>
            </div>
            <VoiceMealLogger 
              childId={childId}
              onMealLogged={handleMealLogged}
            />
          </div>
        </div>
      </div>
      
      <div className="bg-zinc-950/30 border border-zinc-800 backdrop-blur-sm p-6">
        <MealTracker 
          childId={childId}
          childName={childName}
        />
      </div>
      
      {/* Meal Planner - Spoonacular Integration */}
      <MealPlanner 
        childId={childId}
        childName={childName}
        targetCalories={2000}
      />
    </div>
  );
}
